<template>
  <div class="layerContainer">
    <appLayerItem
      v-for="(item, index) in items"
      :key="index"
      :item="item"
      :index="index"
      :updateItem="updateItemAction"
      :defaultItemProps="defaultItemProps"
    ></appLayerItem>
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

import LayerItem from "../imageEditor/LayerItem";

export default {
  components: {
    appLayerItem: LayerItem
  },
  props: ["type"],
  computed: {
    ...mapState(useImageEditorStore, [
      "getLayerItems",
      "getLayerItemsDefaults"
    ]),
    items: function () {
      return this.getLayerItems(this.type);
    },
    defaultItemProps: function () {
      return this.getLayerItemsDefaults(this.type);
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, ["updateItem"]),
    updateItemAction(index, data) {
      this.updateItem({
        type: this.type,
        index: index,
        props: data
      });
    }
  }
};
</script>
